import { ResourceService } from './../../../services/resource.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { BookingService } from 'src/app/services/booking.service';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, Renderer2 } from '@angular/core';
import { DepositPolicyPaymentTypes } from 'src/app/models/enums/BookingEnums';
import { PaymentGatewayMethodEnum, PaymentMethodsEnum, PaymentMode, PaymentSharedComponentErrors, ProceedPaymentResponseResult, RentalServiceDeliveryChannel } from 'src/app/models/enums/Payments/PaymnetsEnum';
import { AvailablePaymentMethodModel } from 'src/app/models/Payments/AvailablePaymentMethodModel';
import { ProceedPaymentModel } from 'src/app/models/Payments/ProceedPaymentModel';
import { Router } from '@angular/router';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { CustomerSummaryModel } from 'src/app/models/Profile/CustomerSummaryModel';
import { FormGroup } from '@angular/forms';


declare const paylib: any;
declare const payTabsInit: any;
@Component({
  selector: 'payment-shared',
  templateUrl: './payment-shared.component.html',
  styleUrls: ['./payment-shared.component.scss']
})
export class PaymentSharedComponent implements OnInit, OnDestroy {
  pastedNameOnCard = '';
  pastedCardNumber = '';
  pastedCVC = '';

  form: FormGroup;
  selected: string = '';
  faTimesCircle = faTimesCircle;
  @Input() depositeType: DepositPolicyPaymentTypes;
  @Input() caseID: string;
  @Input() paymentMode: PaymentMode;
  @Input() paymentValue: number;
  @Input() rentalServiceDeliveryChannel: RentalServiceDeliveryChannel;
  @Input() customerID: string;
  @Output() onAnyError = new EventEmitter();
  selectedMethod;
  PaymentMethods;
  paymentMethodList: AvailablePaymentMethodModel[];
  payTabsPaymentMethod: AvailablePaymentMethodModel;
  customer: any;
  customerDetails: any;
  payTabsFormIsDisable: boolean;
  paymentGatewayMethod: PaymentGatewayMethodEnum;
  accountCreditPostBackMsg: any;
  payTabSetting: any;
  customerSummary: CustomerSummaryModel;
  payPalPostBackMsg: any;
  validateMsg1: boolean = false;
  validateMsg2: boolean = false;
  isExportable: boolean;
  constructor(
    private bookingService: BookingService,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private resourceService: ResourceService,
    private renderer: Renderer2
  ) { }
  ngOnDestroy(): void {
    this.resourceService.updatePaymentFlag(false);
  }

  ngOnInit() {

    this.resourceService.updatePaymentFlag(true);

    this.resourceService.isExportableComponent.subscribe(res =>{
      this.isExportable=res;
    })
    let customerDetails = {
      name: 'ToBeUpdated For Mobile',
      email: 'ToBeUpdated',
      country: "BR",
      street1: 'Test',
      city: "AMM",
    }
    this.authService.loggedInCustomer.subscribe(res => {

      if (res != null) {
        this.customer = res;
        this.customerID = res.customerID;
        //Todo: !!
        // customerDetails = {
        //   name: this.customer.defaultName,
        //   email: this.customer.primaryEmail,
        //   country: "BR",
        //   street1: 'Test',
        //   city: "AMM",
        // }

      }
      else {
        //The customer ID should be delivered from the query params
      }
      //this.customerDetails = customerDetails;


      this.getCustomerDetails(this.customerID);



    })






  }


  onPasteNameOnCard(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText1 = clipboardData.getData('text');
    this.pastedNameOnCard = pastedText1;
  }

  onPasteCardNumber(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText2 = clipboardData.getData('text');
    this.pastedCardNumber = pastedText2;
  }

  onPasteCVC(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText3 = clipboardData.getData('text');
    this.pastedCVC = pastedText3;
  }



  get DepositPolicyPaymentTypes() {
    return DepositPolicyPaymentTypes;
  }

  get paymentMethods() {
    return PaymentMethodsEnum;
  }

  get tenantRegisteredPaymentGatewayMethods() {
    if (this.paymentMethodList == null || this.selectedMethod == null) {
      return null;
    }
    let paymentMehtods = this.paymentMethodList.filter(a => a.paymentGatewayLookupID == this.selectedMethod);
    if (paymentMehtods != null) {
      return paymentMehtods[0].lstTenantRegisteredPaymentGatewayMethods;
    }
    return null;
  }

  get PaymentMode() {
    return PaymentMode;
  }
  get RentalServiceDeliveryChannel() {
    return RentalServiceDeliveryChannel;
  }

  get paymentGatewayMethodEnum() {
    return PaymentGatewayMethodEnum;
  }

  get payTabsPaymentMethods() {
    if (this.paymentMethodList != null) {

      let payTabPaymentMethod = this.paymentMethodList.filter(a => a.paymentGatewayLookupID == PaymentMethodsEnum.PayTabs)[0];
      if (payTabPaymentMethod != null) {
        return payTabPaymentMethod.lstTenantRegisteredPaymentGatewayMethods.filter(a => a.isActive);
      }

    }
    return null;

  }

  changeComboo(event) {

    if (event.value == PaymentMethodsEnum.PayTabs) {
debugger;
      let payTabMethod = this.payTabsPaymentMethod;
      if (payTabMethod != null) {
        let payTabSetting = JSON.parse(payTabMethod.registeredPaymentGatewaySettingsJson);
        this.payTabSetting = payTabSetting;
        setTimeout(() => {
          payTabsInit(payTabSetting.ClientKey, this.onSubmitPayTabs, this.updatePayTabsCardType, this.clearPayTabErrors, this);
        });
      }
    }
  }


  onSubmitPayTabs(response) {

debugger;
    document.getElementById('paymentErrors').innerHTML
    if (response != null && response.token != null) {
      this.accountCreditPostBackMsg = null;

      let paymentMethod = PaymentMethodsEnum.PayTabs;
      let req: ProceedPaymentModel = {

        caseID: this.caseID,
        depositeTypeEnum: this.depositeType,
        paymentMethod: paymentMethod,
        paymentMode: this.paymentMode,
        rentalServiceDeliveryChannelID: this.rentalServiceDeliveryChannel,
        payTabsToken: response.token,
        payTabsCustomerDetails: this.getPayTabsCustomerDetails()
      }





      if (this.paymentMode == PaymentMode.SeparatePay) {
        if (this.paymentValue == null) {
          //Todo: Add event emiter output for validation
          this.onAnyError.emit(PaymentSharedComponentErrors.NoAmount);
          payTabsInit(this.payTabSetting.ClientKey, this.onSubmitPayTabs, this.updatePayTabsCardType, this.clearPayTabErrors, this);
          return;
        }
        req.paymentValue = this.paymentValue;
      }

      this.callProceedPayment(paymentMethod, req);


    }
    if (response.error) {

      if (response.errorField) {
        if (response.errorCode) {
          switch (response.errorCode) {
            case 1001:
              this.translate.get('CardNumberIsNotValid').subscribe(res => {
                response.errorText = res;
              })
              break;
            case 1002:
              this.translate.get('CardTypeIsNotSupported').subscribe(res => {
                response.errorText = res;
              })
              break;
            case 1003:
              this.translate.get('CardExpiryIsNotValid').subscribe(res => {
                response.errorText = res;
              })
              break;
            case 1004:
              this.translate.get('CardSecurityCodeIsNotValid').subscribe(res => {
                response.errorText = res;
              })
              break;
          }
        }
        this.showError(response.errorField, response.errorText);
        return;
      }
    }


  }

  showError(elm, msg) {
    document.getElementById(elm).classList.add("is-invalid");
    document.getElementById(elm + "-feedback").innerHTML = msg;
    document.getElementById(elm + "-feedback").classList.add("d-block");
    document.getElementById(elm).scrollIntoView();
  };

  updatePayTabsCardType(ct, accepted) {
    switch (ct) {
      case "visa":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.Visa;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-visa-brand"></i>';

        if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.Visa)[0] != null) {
          this.payTabsFormIsDisable = false;
          document.getElementById('paymentErrors').innerHTML = '';
        } else {
          this.payTabsFormIsDisable = true;
          this.translate.get('CardNotSupported').subscribe(res => {
            document.getElementById('paymentErrors').innerHTML = res;
          })
        }


        break;
      case "electron":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-electron-brand"></i>';
        this.payTabsFormIsDisable = true;
        this.translate.get('SomethingWentWrong').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        })

        break;
      case "mastercard":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.MasterCard;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-mastercard-brand"></i>';

        if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.MasterCard)[0] != null) {
          this.payTabsFormIsDisable = false;
          document.getElementById('paymentErrors').innerHTML = '';
        } else {
          this.payTabsFormIsDisable = true;
          this.translate.get('CardNotSupported').subscribe(res => {
            document.getElementById('paymentErrors').innerHTML = res;
          })
        }

        break;
      case "maestro":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-maestro-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });

        break;
      case "amex":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.AmericanExpress;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-amex-brand"></i>';

        if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.AmericanExpress)[0] != null) {
          this.payTabsFormIsDisable = false;
          document.getElementById('paymentErrors').innerHTML = '';
        } else {
          this.payTabsFormIsDisable = true;
          this.translate.get('CardNotSupported').subscribe(res => {
            document.getElementById('paymentErrors').innerHTML = res;
          })
        }
        break;
      case "discover":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-discover-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });
        break;
      case "jcb":
        //this.paymentGatewayMethod=PaymentGatewayMethodEnum.Visa;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-jcb-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });
        break;
      case "diners":
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-diners-brand"></i>';
        break;
      case "mada":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.Mada;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-mada-brand"></i>';

        if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.Mada)[0] != null) {
          this.payTabsFormIsDisable = false;
          document.getElementById('paymentErrors').innerHTML = '';
        } else {
          this.payTabsFormIsDisable = true;
          this.translate.get('CardNotSupported').subscribe(res => {
            document.getElementById('paymentErrors').innerHTML = res;
          })
        }
        break;
      case "omannet":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-omannet-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });

        break;
      case "cup":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.UnionPay;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-cup-brand"></i>';



        if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.UnionPay)[0] != null) {
          this.payTabsFormIsDisable = false;
          document.getElementById('paymentErrors').innerHTML = '';
        } else {
          this.payTabsFormIsDisable = true;
          this.translate.get('CardNotSupported').subscribe(res => {
            document.getElementById('paymentErrors').innerHTML = res;
          })
        }
        break;
      case "meeza":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-meeza-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });

        break;
      default:
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-credit-card-brand"></i>';
    }
  };

  clearPayTabErrors() {
    let payForm = document.getElementById('payform');
    var elements = payForm.querySelectorAll(
      ".invalid-feedback, .is-invalid, input[type=text]"
    );
    for (var i = 0, element;
      (element = elements[i++]);) {
      if (element.classList.contains("invalid-feedback")) {
        element.innerHTML = "";
      } else {
        element.classList.remove("is-invalid");
      }
    }
  }

  proceedPayment(paymentMethod) {
    debugger;
    this.accountCreditPostBackMsg = null;

    let req: ProceedPaymentModel = {

      caseID: this.caseID,
      depositeTypeEnum: this.depositeType,
      paymentMethod: paymentMethod,
      paymentMode: this.paymentMode,
      rentalServiceDeliveryChannelID: this.rentalServiceDeliveryChannel
    }
    if (this.paymentMode == PaymentMode.SeparatePay) {
      if (this.paymentValue == null) {
        //Todo: Add event emiter output for validation
        this.onAnyError.emit(PaymentSharedComponentErrors.NoAmount);
        return;
      }
      req.paymentValue = this.paymentValue;
    }

    this.callProceedPayment(paymentMethod, req);

  }

  callProceedPayment(paymentMethod, req) {
    debugger;
    this.bookingService.proceedPayment(req).subscribe(res => {

      if (res != null) {
        switch (paymentMethod) {
          case PaymentMethodsEnum.PayPal:

            this.handlePayPalResponse(res);
            break;
          case PaymentMethodsEnum.AccountCredit:

            this.handleAccountCreditResponse(res);
            break;
          case PaymentMethodsEnum.NoPaymentRequired:
            this.handleAccountCreditResponse(res["result"]);
            break;
          case PaymentMethodsEnum.PayTabs:
            this.handlePayTabsResponse(res);
            break;
        }

      }



    },
    err=>{
      this.router.navigate(['/FailurePayment']);
    })
  }

  handlePayPalResponse(res) {
    let result = res["result"];

    switch (result) {
      case ProceedPaymentResponseResult.Success:
        window.location.href = res['url'];
        break;
      case ProceedPaymentResponseResult.YouTookTooMuchTime:
        this.payPalPostBackMsg = "YouTookTooMuchTime";
        break;
      default:

        break;
    }

  }


  handlePayTabsResponse(res: Object) {
    debugger;
    let result = res["result"];

    switch (result) {
      case ProceedPaymentResponseResult.Success:
        this.router.navigate(['./ConfirmationComponent', { caseID: this.caseID }]);
        break;
      case ProceedPaymentResponseResult.Required3DAuth:
        window.location.href = res['url'];
        break;
      case ProceedPaymentResponseResult.YouTookTooMuchTime:

        this.translate.get('YouTookTooMuchTime').subscribe(res => {
          this.validateMsg2 = true;
          document.getElementById('tookTooMuchTime').innerHTML = res;
        })
        break;
      case ProceedPaymentResponseResult.Failed:
        window.location.href = res['url'];


        // this.translate.get('SomethingWentWrong').subscribe(res => {
        //   this.validateMsg1 = true;
        //   document.getElementById('paymentErrors').innerHTML = res;
        // })

        break;
    }

  }

  handleAccountCreditResponse(res) {
    let result = res["result"];

    switch (result) {
      case ProceedPaymentResponseResult.Success:
        this.router.navigate(['./ConfirmationComponent', { caseID: this.caseID }]);
        break;
      case ProceedPaymentResponseResult.YouTookTooMuchTime:
        this.accountCreditPostBackMsg = "YouTookTooMuchTime";
        break;

      default:
        this.accountCreditPostBackMsg = res["msg"];
        break;
    }

  }
  handleNoRequiredPaymentResponse(res) {
    let result = res["result"];

    switch (result) {
      case ProceedPaymentResponseResult.Success:
        this.router.navigate(['./ConfirmationComponent', { caseID: this.caseID }]);
        break;
      default:
        this.accountCreditPostBackMsg = res["msg"];
        break;
    }

  }

  getCustomerDetails(customerID) {

    this.authService.getCustomerSummary(customerID).subscribe(res => {
      this.customerSummary = res;
      this.getAvailablePaymentMethods();
    })

  }

  getAvailablePaymentMethods() {

    if(this.rentalServiceDeliveryChannel == RentalServiceDeliveryChannel.Walkin)
    this.rentalServiceDeliveryChannel = RentalServiceDeliveryChannel.Online;

    this.bookingService.getAvailablePaymentMethods(this.customerSummary.customerID,this.rentalServiceDeliveryChannel).subscribe(res => {
      if (res != null) {
        this.paymentMethodList = res.filter(a => a.isActive);
        this.payTabsPaymentMethod = this.paymentMethodList.filter(a => a.paymentGatewayLookupID == PaymentMethodsEnum.PayTabs)[0];

      }
    })
  }
  getPayTabsCustomerDetails() {
    let customerDetails = {
      name: this.customerSummary.defaultName,
      email: this.customerSummary.primaryEmail,
      country: this.customerSummary.iso,
      street1: this.customerSummary.iso,
      city: this.customerSummary.iso,
    }
    return customerDetails;
  }


}
